import React from 'react';
import style from './PrimeraParte.module.css';
import { useTranslation } from 'react-i18next';

const PrimeraParte = ({ t: tProp }) => {
  const { t: tHook } = useTranslation();
  const t = tProp || tHook;

  return (
    <div className={style.container}>
      {/* TÍTULO PRINCIPAL */}
      <p className={style.titulo}>
        {t('Products.sscEnterprise.FirstPart.title')}&nbsp;
        {t('Products.sscEnterprise.FirstPart.title2')}
      </p>

      <div className={style.divContainer}>
        {/* COLUMNA IZQUIERDA */}
        <div className={style.divIzq}>
          <p className={style.text}>{t('Products.sscEnterprise.FirstPart.text')}</p>
          <p className={style.text}>{t('Products.sscEnterprise.FirstPart.text2')}</p>
          <p className={style.text}>{t('Products.sscEnterprise.FirstPart.text3')}</p>          
          <p className={style.text}>{t('Products.sscEnterprise.FirstPart.text4')}</p>          
        </div>

        {/* COLUMNA DERECHA */}
        <div className={style.divDer}>
          <p className={style.title}>{t('Products.sscEnterprise.FirstPart.title3')}</p>
          <div className={style.separador}></div>

          <ul className={style.ul}>
            <li className={style.li}>{t('Products.sscEnterprise.FirstPart.li')}</li>
            <li className={style.li}>{t('Products.sscEnterprise.FirstPart.li2')}</li>
            <li className={style.li}>{t('Products.sscEnterprise.FirstPart.li3')}</li>
            <li className={style.li}>{t('Products.sscEnterprise.FirstPart.li4')}</li>
            <li className={style.li}>{t('Products.sscEnterprise.FirstPart.li5')}</li>
          </ul>

          <p className={style.title}>{t('Products.sscEnterprise.FirstPart.title4')}</p>
          <div className={style.separador}></div>

          <ul className={style.ul}>
            <li className={style.li}>{t('Products.sscEnterprise.FirstPart.li6')}</li>
            <li className={style.li}>{t('Products.sscEnterprise.FirstPart.li7')}</li>
            <li className={style.li}>{t('Products.sscEnterprise.FirstPart.li8')}</li>
            <li className={style.li}>{t('Products.sscEnterprise.FirstPart.li9')}</li>
            <li className={style.li}>{t('Products.sscEnterprise.FirstPart.li10')}</li>
          </ul>

        </div>
      </div>
    </div>
  );
};

export default PrimeraParte;
